import React from "react";
import { CloseIcon, LoadingImgIcon } from "../../../assets/icons";

function UserProfile({ visible, onClose, data }) {
  const handleOnClose = (e) => {
    if (e.target.id === "modal") onClose();
  };
  if (!visible) return null;
  return (
    <div
      id="modal"
      onClick={handleOnClose}
      className="bg-black bg-opacity-30 fixed inset-0 backdrop-blur-sm flex justify-center items-center z-10"
    >
      <div className="bg-white p-2 rounded w-[55%]  ">
        <div className="flex items-start justify-between px-5 py-2  rounded-t">
          <h3 className="text-sm 2xl:text-base font-semibold">User View</h3>
          <span
            className="h-6 w-6 text-2xl block cursor-pointer"
            onClick={onClose}
          >
            <CloseIcon />
          </span>
        </div>
        <div className=" max-h-[80vh] overflow-y-auto px-4">
          <div className="grid grid-cols-2 grid-rows-6 gap-3">
            <div className="row-span-3 rounded-md border-[2px]  flex justify-center items-center border-primary overflow-hidden shadow-box bg-slate-50 ">
              {(data?.user?.image_path != "" && data?.user?.image_path != null )? (
                <>
                  <img src={data?.user?.image_path} alt="#" width="100%" />
                </>
              ) : (
                <>
                  <LoadingImgIcon
                    height="h-24"
                    width="w-24"
                    color="text-gray-200"
                  />
                </>
              )}
            </div>
            <div>
              <TempComp label="Name" value={data?.user?.name || "-"} />
            </div>
            <div className="col-start-2">
              <TempComp
                label="User Name"
                value={data?.user?.user_name || "-"}
              />
            </div>
            <div className="col-start-2 row-start-3">
              <TempComp
                label="Role"
                value={data?.user?.role[0]?.roleName || "-"}
              />
            </div>
            <div className="col-start-1 row-start-4">
              <TempComp label="Mobile" value={data?.user?.mobile || "-"} />
            </div>
            <div className="col-start-2 row-start-4">
              <TempComp label="Email" value={data?.user?.email || "-"} />
            </div>
            <div className="col-start-1 row-start-5">
              <TempComp label="Country" value={data?.user?.country || "-"} />
            </div>
            <div className="col-start-2 row-start-5">
              <TempComp label="City" value={data?.user?.location || "-"} />
            </div>
            <div className="col-start-1 row-start-6">
              <TempComp
                label="Department"
                value={data?.user?.department || "-"}
              />
            </div>
            <div>
              <TempComp
                label="Email Sending"
                value={data?.isEmailSent == true ? "Yes" : "No" || "-"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;

function TempComp({ label, value }) {
  return (
    <div className="my-2 text-left">
      <p className="text-sm text-[#1D1818] font-semibold mb-1 pl-8">{label}</p>
      <p className="text-xs text-[#6E6985] font-semibold text-main-title bg-[#FDFAFF] py-3 pl-8">
        {value || "-"}
      </p>
    </div>
  );
}
